import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovaoustationcabrentalsfrompune() {



  const cardData =
  {
    keyword: 'Innova Outstation Cab Rentals from Pune',
    heading: 'Aaryan Travels: Innova Outstation Cab Rentals from Pune',
    headingDescription: 'Aaryan Travels offers reliable Innova Outstation Cab Rentals from Pune for family trips, corporate journeys, pilgrimages, and long-distance travel. Whether you are heading to Mahabaleshwar, Shirdi, Goa, Nashik, Mumbai, or any other destination, our well-maintained Toyota Innova and Innova Crysta ensure a spacious, comfortable, and safe ride. With experienced chauffeurs, dual AC, ample luggage space, and round-the-clock availability, we make outstation travel smooth and convenient. Choose from one-way or round-trip rental options with transparent fares and doorstep pickup anywhere in Pune. For a stress-free outstation journey with added comfort, Aaryan Travels is the preferred choice for Innova cab rentals.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it still echoes tales of Bajirao and Mastani. Visitors explore its grand gateways, sprawling lawns, and historical ruins. The evening light-and-sound show recreates Maratha history in a captivating way. Shaniwar Wada is Pune’s proud symbol of legacy and power."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace played a significant role in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with preserved belongings of Gandhi. Its lush gardens and serene ambiance attract history lovers. Aga Khan Palace is Pune’s monument of patriotism and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched on a hill 25 km from Pune, is famous for the heroic battle of 1670 led by Tanaji Malusare. Trekkers enjoy scenic trails and misty surroundings, especially during monsoon. The fort provides panoramic views of the Sahyadri mountains. Local vendors serve traditional pithla-bhakri meals at the top. Sinhagad is Pune’s perfect blend of adventure and history."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks. The richly adorned idol of Lord Ganesha attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. Devotees experience peace and blessings here. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Featuring monolithic pillars and a Nandi mandap, it reflects ancient Indian stone architecture. Despite being in the city center, it offers a quiet and spiritual retreat. Evening chants enhance its mystical aura. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected from across India. Its exhibits include musical instruments, sculptures, ornaments, and everyday antiques. The recreated Mastani Mahal is a major attraction for visitors. History enthusiasts find it deeply engaging. The museum is Pune’s treasure house of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers breathtaking views of Pune from its summit. Visitors climb 103 stone steps to reach the historic temple dedicated to Lord Shiva and Goddess Parvati. The temple, built during the Peshwa era, exudes spiritual charm. Sunrises and sunsets from the hill are mesmerizing. Parvati Hill is Pune’s peaceful lookout of devotion."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is an international meditation retreat surrounded by lush gardens and modern architecture. It offers wellness programs, healing sessions, and mindfulness workshops. The calm ambiance attracts visitors from all over the world. Osho Ashram is Pune’s global haven of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Modeled after Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene environment. Families enjoy peaceful walks, picnics, and photography sessions. The seasonal blossoms add to its charm. The garden is Pune’s refreshing green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The scenic reservoir and surrounding hills offer beautiful sunset views. Monsoon makes it even more picturesque. Street vendors selling hot corn and chai add to the experience. Khadakwasla is Pune’s breezy escape into nature."
  }
],


"services": [
  {
    "name": "Innova Outstation Cab Rentals from Pune",
    "description": "Innova Outstation Cab Rentals from Pune offer spacious and reliable transportation for long-distance travel. Ideal for family trips, business tours, or weekend getaways, our service ensures comfort, safety, and professional chauffeurs to make your journey smooth and enjoyable."
  },
  {
    "name": "Outstation Innova Cab Pune",
    "description": "Outstation Innova Cab Pune provides well-maintained Toyota Innovas for travel outside the city. With ample luggage space, comfortable seating, and experienced drivers, it's perfect for group travel and intercity journeys from Pune to nearby destinations."
  },
  {
    "name": "Pune Innova Outstation Hire",
    "description": "Pune Innova Outstation Hire is designed for travelers seeking reliable and comfortable transportation beyond Pune. Our fleet of Innovas is available for one-way or round-trip travel, with flexible booking options and professional chauffeurs ensuring timely service."
  },
  {
    "name": "Innova for Long Trips Pune",
    "description": "Innova for Long Trips Pune offers premium vehicles for extended journeys across Maharashtra and beyond. Our Innova cabs are ideal for road trips, featuring air conditioning, spacious interiors, and drivers skilled in handling long-distance routes."
  },
  {
    "name": "Chauffeur Driven Innova Pune",
    "description": "Chauffeur Driven Innova Pune provides luxury and convenience for outstation travel with expert drivers. Enjoy a relaxed and safe journey with a courteous chauffeur, whether you're heading out for a vacation, wedding, or business trip."
  },
  {
    "name": "Best Innova Outstation Pune",
    "description": "Best Innova Outstation Pune is recognized for its reliable service, clean vehicles, and punctual drivers. We prioritize customer satisfaction, offering well-equipped Innovas for comfortable outstation travel from Pune to popular nearby cities and tourist destinations."
  },
  {
    "name": "Affordable Innova Rental Pune",
    "description": "Affordable Innova Rental Pune offers competitive pricing on outstation travel without compromising on comfort or safety. Ideal for budget-conscious travelers, our service includes transparent billing, experienced drivers, and clean, well-maintained vehicles."
  },
  {
    "name": "Corporate Innova Pune",
    "description": "Corporate Innova Pune caters to business clients needing dependable outstation transport. With professional chauffeurs, priority bookings, and invoicing support, this service is ideal for corporate events, team outings, and executive travel."
  },
  {
    "name": "Pune Innova Taxi Outstation",
    "description": "Pune Innova Taxi Outstation provides door-to-door pickup and drop services for intercity travel. Our spacious Innovas accommodate groups and families, ensuring a smooth and enjoyable ride with flexible schedules and courteous drivers."
  },
  {
    "name": "Innova SUV Hire Pune",
    "description": "Innova SUV Hire Pune offers premium SUV rentals for local and outstation trips. With ample legroom, luggage space, and top-notch maintenance, our Innova SUVs are perfect for comfortable long-distance travel with family or colleagues."
  },
  {
    "name": "Innova Car for Outstation Pune",
    "description": "Innova Car for Outstation Pune provides reliable transportation for those planning to travel outside the city. Book an Innova for your weekend getaway, pilgrimage, or corporate trip and enjoy a smooth journey with trained, professional drivers."
  },
  {
    "name": "One Way Innova Pune",
    "description": "One Way Innova Pune offers convenient and cost-effective one-way trips from Pune to various destinations. Avoid round-trip fares and pay only for the distance traveled, while enjoying a comfortable ride in our well-equipped Innova cabs."
  },
  {
    "name": "Round Trip Innova Pune",
    "description": "Round Trip Innova Pune is ideal for travelers planning to return to Pune after their journey. Our service includes waiting time, return convenience, and experienced drivers, making it suitable for day trips, vacations, and business visits."
  },
  {
    "name": "Innova Tour Cab Pune",
    "description": "Innova Tour Cab Pune offers customized tour packages for popular destinations around Pune. Our spacious Innovas and knowledgeable drivers make sightseeing comfortable and informative, perfect for family holidays and group tours."
  },
  {
    "name": "Innova Rental Packages Pune",
    "description": "Innova Rental Packages Pune provides flexible hourly and daily rental options for outstation travel. Choose from our affordable packages based on your travel needs, and enjoy clean vehicles, professional service, and complete billing transparency."
  }
],
"tableData": [
  ["Innova Outstation Cab Rentals from Pune", "Outstation Innova Cab Pune"],
  ["Pune Innova Outstation Hire", "Innova for Long Trips Pune"],
  ["Chauffeur Driven Innova Pune", "Best Innova Outstation Pune"],
  ["Affordable Innova Rental Pune", "Corporate Innova Pune"],
  ["Pune Innova Taxi Outstation", "Innova SUV Hire Pune"],
  ["Innova Car for Outstation Pune", "One Way Innova Pune"],
  ["Round Trip Innova Pune", "Innova Tour Cab Pune"],
  ["Innova Rental Packages Pune", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Innova Outstation Cab Rentals from Pune",
    "WhyChoosedescription": "Aaryan Travels offers reliable Innova cab rentals for comfortable and spacious outstation trips from Pune."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Hassle-Free Travel",
    "WhyChoosedescription": "Our drivers ensure timely pickups and drop-offs so your outstation journey starts and ends smoothly."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Innova Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned Innova cars that guarantee comfort for long-distance trips."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Outstation Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes around Pune and beyond for efficient and safe travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get upfront pricing covering fuel, tolls, and driver allowances for a worry-free rental experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with your Innova outstation bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Your Travel Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rentals tailored to your outstation travel plans."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Travel",
    "WhyChoosedescription": "Enjoy ample space for passengers and luggage, making your outstation trip relaxing and enjoyable."
  }
]



































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Innova outstation cab rentals from Pune?',
    answer: 'Yes, Aaryan Travels provides reliable Innova outstation cab rentals from Pune for comfortable and spacious travel.',
  },
  {
    question: 'How can I book Innova outstation cab rentals from Pune with Aaryan Travels?',
    answer: 'You can book easily via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'Are Innova cabs available for both one-way and round-trip outstation journeys from Pune?',
    answer: 'Yes, Aaryan Travels offers Innova cabs for both one-way and round-trip outstation rentals from Pune.',
  },
  {
    question: 'Are the drivers experienced with outstation routes from Pune?',
    answer: 'Absolutely. Our professional drivers are licensed and knowledgeable about popular outstation routes starting from Pune.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Innova outstation rentals from Pune?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and your outstation destination.',
  },
  {
    question: 'Is Innova outstation cab service available 24x7 for bookings from Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock booking services for Innova outstation cab rentals from Pune.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Innova outstation cabs?',
    answer: 'All Innova vehicles are regularly sanitized, and drivers follow strict safety and hygiene measures.',
  },
  {
    question: 'What payment options are accepted for Innova outstation cab rentals from Pune?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during Innova outstation cab journeys from Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'The Innova outstation cab from Aaryan Travels made our Pune to Lonavala trip comfortable and hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Sharma',
    feedback: 'Spacious and well-maintained Innova cab for our Pune outstation journey. Excellent service by Aaryan Travels!',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const innovaOutstationCabPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Innova Outstation Cab Rentals from Pune",
  "description": "Aaryan Travels provides chauffeur-driven Innova outstation cab rentals from Pune for long trips, corporate travel, and round trips with affordable packages.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Innova Outstation Cab Rental",
  "keywords": "Innova Outstation Cab Rentals from Pune, Outstation Innova Cab Pune, Pune Innova Outstation Hire, Innova for Long Trips Pune, Chauffeur Driven Innova Pune, Best Innova Outstation Pune, Affordable Innova Rental Pune, Corporate Innova Pune, Pune Innova Taxi Outstation, Innova SUV Hire Pune, Innova Car for Outstation Pune, One Way Innova Pune, Round Trip Innova Pune, Innova Tour Cab Pune, Innova Rental Packages Pune"
};










  return (
    <div>

<Helmet>
  <title>Innova Outstation Cab Rentals from Pune | Chauffeur Driven Innova Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book Innova outstation cab rentals from Pune with Aaryan Travels. Chauffeur-driven Innova for long trips, corporate travel, round trips, and affordable rental packages."
  />
  <meta
    name="keywords"
    content="Innova Outstation Cab Rentals from Pune, Outstation Innova Cab Pune, Pune Innova Outstation Hire, Innova for Long Trips Pune, Chauffeur Driven Innova Pune, Best Innova Outstation Pune, Affordable Innova Rental Pune, Corporate Innova Pune, Pune Innova Taxi Outstation, Innova SUV Hire Pune, Innova Car for Outstation Pune, One Way Innova Pune, Round Trip Innova Pune, Innova Tour Cab Pune, Innova Rental Packages Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaOutstationCabPuneSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovaoustationcabrentalsfrompune;